import React from 'react';

import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

import { getValue } from '@/helpers/GetValueHelper';

export type TProps = {
  data: TRecommendation;
};

export const Image = React.memo(({ data }: TProps) => {
  const [image, description] = [
    getValue(data, 'image[0].image', getValue(data, 'image[0]', "")) as string,
    getValue(data, 'image[0].description', "") as string,
  ];

  return image ? (
    <img className="vitrine-template1__image" src={image} alt={description} />
  ) : (
    <></>
  );
});
